import * as FilerrsActionTypes from '../../types/filerrs';

export default function filerrs(state = {}, action = {}) {
    switch (action.type) {
        case FilerrsActionTypes.SET_FILERRS: {
            return action.payload;
        }

        default: {
            return state;
        }
    }
}
